import Split from './split.vue';
export default Split;



// WEBPACK FOOTER //
// ./src/components/split/index.js